import { _undefined, _freeze, } from '../util/data';
import { _EditMarker, } from '../route-view/route-features';
import { _markerSettings, } from '../route-view/route-feature-settings';
const _routePoint = (latLng, settingsId, route, connections) => {
    const point = _freeze({
        r: () => route,
        m: () => $marker,
        pp: () => previousPoint,
        il: () => incomingLine,
        ol: () => outgoingLine,
        np: () => nextPoint,
        set: (connections) => {
            if (!_undefined(connections.pp)) {
                previousPoint = connections.pp;
            }
            if (!_undefined(connections.il)) {
                incomingLine = connections.il;
            }
            if (!_undefined(connections.ol)) {
                outgoingLine = connections.ol;
            }
            if (!_undefined(connections.np)) {
                nextPoint = connections.np;
            }
            return point;
        },
    }), markerPaneId = route.p().mid(), settings = Object.assign(Object.assign({}, _markerSettings[settingsId]), { pane: markerPaneId }), $marker = new _EditMarker(latLng, settings, point);
    let previousPoint = null, incomingLine = null, outgoingLine = null, nextPoint = null;
    if (connections) {
        point.set(connections);
    }
    return point;
}, _isStart = (point) => (point === point.r().s()), _isEnd = (point) => (point === point.r().e());
export { _routePoint, _isStart, _isEnd, };
